import type { ChatEntryWithSubTables } from "../../../shared/aiSdkMessages";
import type { StreamMessage } from "../../hooks/useStreamingText";
import type { ChatTool } from "./ChatTool";
import { isGroupChat } from "./chatEntries";
import { MessagesContent } from "./chatStyles";
import type { PreviousConversation } from "./chatTypes";
import { groupChatEntries } from "./groupChatEntries";
import { Transcript } from "./Transcript";
import {
  TranscriptProvider,
  useTranscriptExpansionState,
} from "./TranscriptContext";

const noAction = () => {};
const noStreaming = new Map<string, StreamMessage>();

export function PreviousTranscript({
  conversation,
  toolsByName,
  currentUserId,
}: {
  conversation: PreviousConversation;
  toolsByName: Map<string, ChatTool>;
  currentUserId: string | undefined;
}) {
  const expansion = useTranscriptExpansionState(conversation);
  const entries = conversation.entries as ChatEntryWithSubTables[];
  return (
    <MessagesContent>
      <div data-chat-spacer />
      <TranscriptProvider
        value={{
          isGroupChat: isGroupChat(entries),
          currentUserId,
          toolsByName,
          isCurrentUserChat: false,
          canWrite: false,
          onProvideToolResult: noAction,
          onRetryFromError: noAction,
          onTypewriterAnimatingChange: noAction,
        }}
        expansion={expansion}
      >
        <Transcript
          reviewVersion={conversation.reviewVersion}
          entries={entries}
          groupedEntries={groupChatEntries(entries, "resting")}
          streamingEntries={noStreaming}
        />
      </TranscriptProvider>
    </MessagesContent>
  );
}
